module.exports = __webpack_public_path__ + "static/media/SFDRN.85f6667e.pdf";